import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  useMemo,
} from 'react'
import fetch from 'lib/decorated-fetch'
import get from 'lodash/get'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import { stringify } from 'querystring'
import ScrollLoader from 'Components/scroll-loader'
import Head from 'Components/head'
import QRCode from 'Components/qr-code'
import Loading from 'Components/loading'
import getUrl from 'lib/url'
import fetchCommunityFeed, { IFeedData } from 'lib/fetch-community-feed'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { GlobalStoreContext } from 'Components/store'
import HeaderInfo from './header-info'
import TabList from './tabList'
import FeedList from './feedList'
import Breadcrumb from 'Components/breadcrumb'
import Button from 'Components/button'
import RecommendCommunities from './recommend-communities'
import { IReSolvedFeedCard } from 'Pages/car_fans_community/home'
import QA from 'Pages/car_fans_community/qa'
import Modal from 'Components/modal'
import Publisher, { IPB } from 'Components/publisher/publisher'
import { useCityName } from 'Components/hooks'
import { FeedContext } from 'Pages/car_fans_community/feed'
import { mockNewCard } from 'lib/mock-new-card'
import { CloseIconForPublisher } from 'Components/publisher/close-icon'
import { isNewVersion } from 'lib/version'
import useLoginCheckCallback from 'Components/hooks/use-login-check-callback'

const publish_icon = require('static/publish@3x.png')
const empty_icon = require('static/empty-envelope.png')

export interface TabItem {
  chi_name: string
  tab_name: string
  dropdown_enter_name: string
  dropdown_list: {
    tab_filter_show_name: string
    name: string
    tab_filter_select_name: string
  }[]
}

export interface ConcernInfo {
  joined_days: string
  sign_desc: string
  has_master: boolean
  master_info: any
  sub_master_info: any
  sign_in: number
  sign_count: number
  show_join_button: boolean
  is_concern: number
  user_amount: number
  concern_user_info: {
    user_avatar_list: {
      avatar_url: string
    }[]
  }
}

export interface CarInfo {
  image_url: string
  brand_logo: string
  car_id_type: number
  series_name: string
  series_id: number
  motor_type: number
  motor_id: number
  motor_name: string
  concern_info: ConcernInfo
  series_open_url: string
}

interface HeaderData {
  tab_info_v2: {
    tab_list: TabItem[]
    enter_tab_name: string
  }
  car_info: CarInfo
  community_info: {
    join_tips: string
    community_desc: string
  }
  type: number
}

interface IProps {
  headerData: HeaderData
  tab: string
  series_id: string
}
const tab_list = [
  {
    chi_name: '动态',
    tab_name: 'dongtai',
    dropdown_list: [
      {
        tab_filter_show_name: '推荐',
        type: 1,
        name: 'recommend',
        tab_filter_select_name: '按推荐内容排序',
      },
      {
        tab_filter_show_name: '回复时间',
        type: 2,
        name: 'reply',
        tab_filter_select_name: '按回复时间排序',
      },
      {
        tab_filter_show_name: '发布时间',
        type: 2,
        name: 'publish',
        tab_filter_select_name: '按发布时间排序',
      },
    ],
    red_dot_info: { count: 0, show: false },
    dropdown_enter_name: 'reply',
  },
  {
    chi_name: '精华',
    tab_name: 'selected',
    dropdown_list: [
      {
        tab_filter_show_name: '加精时间',
        type: 2,
        name: 'selected',
        tab_filter_select_name: '精华按加精时间排序',
      },
    ],
    dropdown_enter_name: 'selected',
  },
  {
    chi_name: '口碑',
    dropdown_enter_name: 'koubei',
    dropdown_list: [
      {
        tab_filter_show_name: '',
        type: 2,
        name: 'koubei',
        tab_filter_select_name: '',
      },
    ],
    tab_name: 'koubei',
  },
  {
    chi_name: '问答',
    tab_name: 'wenda',
    dropdown_list: [
      {
        tab_filter_show_name: '发布时间',
        type: 2,
        name: 'wenda',
        tab_filter_select_name: '问答按发布时间排序',
      },
    ],
    dropdown_enter_name: 'wenda',
  },
  {
    chi_name: '评车',
    dropdown_enter_name: 'dakareyi',
    dropdown_list: [
      {
        tab_filter_show_name: '发布时间',
        type: 2,
        name: 'dakareyi',
        tab_filter_select_name: '按发布时间排序',
      },
    ],
    tab_name: 'dakareyi',
  },
  {
    chi_name: '商家',
    dropdown_enter_name: 'shangjia',
    dropdown_list: [
      {
        tab_filter_show_name: '发布时间',
        type: 2,
        name: 'shangjia',
        tab_filter_select_name: '按发布时间排序',
      },
    ],
    tab_name: 'shangjia',
  },
]

const getChiName = (name: string) =>
  tab_list.find(({ tab_name }) => tab_name === name)?.chi_name

const Index = ({ headerData, tab, series_id }: IProps) => {
  const { car_info, community_info } = headerData
  const { motor_name, concern_info, motor_id, motor_type } = car_info || {}
  const { community_desc } = community_info || {}
  const [currentTab, setCurrentTab] = useState(tab || tab_list[0].tab_name)
  const [feedList, setFeedList] = useState<IFeedData[]>([])
  const [hasMore, setHasMore] = useState(true)
  const [showPublisher, setShowPublisher] = useState(false)
  const [list, setList] = useState<
    {
      info: IReSolvedFeedCard
      type: number
      unique_id_str: string
    }[]
  >([])
  const [maxCursor, setMaxCursor] = useState(0)
  const cityName = useCityName()
  const { state: globalState } = useContext(GlobalStoreContext)
  const [brand, setBrand] = useState({
    brand_name: '',
    brand_id: '',
  })
  const [loading, setLoading] = useState(false)
  // 处理tab切换的请求竟态
  let switched = false

  useEffect(() => {
    fetch(
      `/motor/car_page/m/v1/get_head/?series_id=${series_id}&city_name=${encodeURIComponent(
        cityName || '北京'
      )}&data_from=pc_station`
    )
      .then((json) => {
        setBrand({
          brand_name: json.concern_obj?.brand_name,
          brand_id: json.concern_obj?.brand_id,
        })
      })
      .catch((e) => {
        // no-op
      })
  }, [series_id])

  const getResolvedFeed = useCallback((query: any) => {
    setLoading(true)
    // cmg_flag 为 wenda 时 替换为 series_wenda_publish
    if (query?.cmg_flag === 'wenda') {
      query.cmg_flag = 'series_wenda_publish'
    }
    return fetch(
      getUrl(`/motor/discuss_ugc/cheyou_feed_list_v3/v1/?${stringify(query)}`),
      {
        method: 'GET',
        credentials: 'include',
      }
    )
      .then(({ data }) => {
        if (data) {
          return data
        }
        return Promise.reject('获取data失败')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    const query = {
      tt_from: maxCursor === 0 ? 'enter_auto' : 'pre_load_more',
      category: 'series_wenda_reply',
      cmg_flag: 'series_wenda_reply',
      motor_id,
      refer: 1,
      count: 10,
      impression_info: {
        sub_tab: 'series_wenda_reply',
        motor_id: '20000960000000',
      },
      city: '北京市',
      motor_feed_extra_params: {
        new_feed: true,
        feed_type: 0,
      },
      max_cursor: maxCursor,
    }
    getResolvedFeed(query).then((res) => {
      setList(res?.list?.slice(0, 10) || [])
    })
  }, [maxCursor])

  const handleShuffle = useCallback(() => {
    sendTeaCommEvent('click_change_qa_list')
    setMaxCursor(list[list.length - 1]?.info?.cursor || 0)
  }, [getResolvedFeed, list])

  const handleClickItem = (motor_id: number, motor_name: string) => {
    sendTeaCommEvent('click_feed_motor_btn', {
      motor_id,
      motor_name,
    })
  }

  const getFeedList = async (type: string) => {
    if (loading || !hasMore) return
    const { motor_id } = headerData?.car_info || {}
    setLoading(true)
    const { paging, list } = await fetchCommunityFeed({
      motor_id,
      series_id,
      tab: currentTab,
      type,
      min_behot_time:
        type === 'load_more' ? get(feedList, '0.info.behot_time', 0) : 0,
      max_behot_time:
        type === 'load_more'
          ? get(feedList, `[${feedList.length - 1}].info.behot_time`, 0)
          : 0,
      max_cursor:
        type === 'load_more'
          ? get(feedList, `[${feedList.length - 1}].info.cursor`, 0)
          : 0,
    })
    if (switched) {
      setLoading(false)
      return
    }
    const filtered =
      (list as IFeedData[])?.filter(
        (item) =>
          //  2300 ~ 2399 是微头条的类型
          item.type >= 2300 && item.type <= 2399
      ) || [] //过滤无效项
    paging.count = filtered.length
    setFeedList(feedList.concat(filtered))
    setHasMore(paging?.has_more)
    if (type === 'refresh') {
      setFeedList(filtered)
    } else {
      setFeedList(feedList.concat(filtered))
    }
    setLoading(false)
  }
  const handleTabClick = (e: any) => {
    const { motor_id, motor_name, motor_type } = car_info || {}
    const { name } = e.target.dataset

    setCurrentTab(name)
    setHasMore(true)
    sendTeaCommEvent('click_ugc_forum_home_tab', {
      motor_id,
      motor_name,
      motor_type,
      sub_tab: name,
    })
  }
  const loadMoreHandler = () => {
    if (!feedList.length) return
    getFeedList('load_more')
  }

  const handleTogglePublisher = useLoginCheckCallback(
    useCallback(() => {
      sendTeaCommEvent('click_forum_home_post', {
        motor_id,
        motor_name,
        motor_type,
      })
      setShowPublisher(!showPublisher)
    }, [showPublisher, motor_id, motor_name, motor_type]),
    useMemo(() => {
      return {
        enter_method: 'publish',
      }
    }, [])
  )

  const handlePublish = async (props: IPB) => {
    const { isTimer } = props

    if (!isTimer) {
      const user_id = globalState?.userData?.user_id
      if (!user_id) {
        return
      }
      const newData = await mockNewCard({ ...props, user_id })
      setFeedList([newData as any, ...feedList])
    }
    setShowPublisher(false)
  }

  const handleDelete = useCallback(
    (gid: string) => {
      setFeedList(feedList.filter((ele) => ele.unique_id_str !== gid))
    },
    [feedList]
  )

  useEffect(() => {
    setFeedList([])
    setHasMore(true)
    getFeedList('refresh')
    return () => {
      switched = true
    }
  }, [currentTab])
  // 切换车系车友圈主页背景色
  useEffect(() => {
    const color = document.body.style.backgroundColor
    document.body.style.backgroundColor = '#f7f8fc'
    return () => {
      document.body.style.backgroundColor = color
    }
  }, [])

  const removeTail = useCallback(
    (str: string) => str?.slice(0, str.indexOf('车友圈')),
    []
  )
  return (
    <div className="article clearfix">
      <Head title={`${motor_name}__懂车帝`} />
      <Breadcrumb
        hideLine={true}
        path={[
          { name: '首页', href: '/home', as: '/' },
          {
            name: brand.brand_name || '车友圈',
            href: !brand.brand_name
              ? ''
              : `/auto/library/x-x-x-x-x-x-x-x-x-x-x?key=brand&param=${brand.brand_id}&text=${brand.brand_name}`,
            as: !brand.brand_name
              ? ''
              : `/auto/library/x-x-x-x-x-x-x-x-x-x-x?key=brand&param=${brand.brand_id}&text=${brand.brand_name}`,
          },
          {
            name: removeTail(car_info?.series_name),
            href: car_info?.series_open_url
              ? `/auto/series?seriesId=${car_info?.series_id}`
              : '',
            as: car_info?.series_open_url
              ? `/auto/series/${car_info?.series_id}`
              : '',
          },
        ]}
      />
      <FeedContext.Provider
        value={{
          onDeletePost: handleDelete,
        }}
      >
        <section className="content fl">
          {/* <TopBanner /> */}
          <HeaderInfo
            concern_info={concern_info || {}}
            car_info={car_info || {}}
            name={motor_name}
            desc={community_desc}
            motor_id={motor_id}
          />
          <div className="bar">
            <TabList
              list={tab_list}
              currentTab={currentTab}
              handleTabClick={handleTabClick}
            />
            <Button
              type="new_primary"
              className="publish-button"
              onClick={handleTogglePublisher}
            >
              <>
                <img src={publish_icon} className="publish-icon" />
                <span className="publish-button-text">发布</span>
              </>
            </Button>
          </div>
          <Modal
            visible={showPublisher}
            onClose={handleTogglePublisher}
            className="publisher-modal"
            closable={true}
            CloseIcon={CloseIconForPublisher}
          >
            <Publisher
              onPublish={handlePublish}
              defaultCommunity={{
                series_id,
                series_name: car_info?.series_name,
              }}
            />
          </Modal>
          <div className="data-wrapper">
            <ScrollLoader
              loading={loading}
              end={!hasMore}
              loadMoreHandler={loadMoreHandler}
            >
              <FeedList list={feedList} car_info={car_info || {}} />
            </ScrollLoader>
            {hasMore && loading ? <Loading /> : null}
            {feedList.length <= 0 && !loading && (
              <span className="no-article">
                <img src={empty_icon} />
                暂无{getChiName(currentTab)}
              </span>
            )}
          </div>
        </section>
      </FeedContext.Provider>

      <aside className="fl right-part">
        <span className="recommend-communities-title title">推荐车友圈</span>
        <RecommendCommunities handleClickItem={handleClickItem} />
        <div className="common-questions">
          <QA onShuffle={handleShuffle} list={list} title="常见问题" />
        </div>
        {/* <Ad /> */}
        <QRCode />
      </aside>
      <style jsx>
        {`
          .article {
            width: 1190px;
            margin: 11px auto 0;
          }
          aside {
            width: 390px;
          }
          .content {
            width: 750px;
            margin-right: 50px;
          }
          .bar {
            display: flex;
            justify-content: space-between;
            width: 800px;
            position: sticky;
            top: 0;
            z-index: 500;
            background-color: #f7f8fc;
          }
          .right-part {
            padding-left: 16px;
          }
          .title {
            color: #1f2129;
            font-size: 24px;
            line-height: 1.5;
            display: block;
            margin-bottom: 16px;
            font-weight: 500;
          }
          .common-questions-title {
            margin-top: 40px;
          }
          .common-questions {
            margin-bottom: 40px;
          }
          :global(.article .publish-button) {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 120px;
            height: 48px;
            border-radius: 2px;
          }

          :global(.publisher-modal) {
            z-index: 1000 !important;
          }

          /*
            注意portal会影响css后代选择器 不可通过设置关系选择器来增加权重 因而直接使用了important
            TODO: 待优化。
          */
          :global(.publisher-modal .modal-body) {
            padding: 0 !important;
            overflow-y: visible !important;
            overflow: visible !important;
          }
          :global(.publisher-modal .modal-container) {
            overflow-y: visible !important;
            overflow: visible !important;
          }
          .publish-icon {
            width: 20px;
            height: 20px;
            object-fit: contain;
            object-position: center;
            margin-right: 4px;
          }
          .publish-button-text {
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
            color: #1f2129;
          }
          .data-wrapper {
            position: relative;
            min-height: 500px;
          }
          .no-article {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: #606370;
            font-size: 14px;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .no-article > img {
            width: 80px;
            height: 80px;
            object-fit: cover;
            object-position: center;
          }
        `}
      </style>
    </div>
  )
}

Index.getInitialProps = async (ctx: any) => {
  const { query, req } = ctx
  const { series_id, tab } = query
  const getHeaderData = async () => {
    const params = {
      aid: 36,
      series_id,
      version_code: '4.7.2',
      version_name: '472',
      device_platform: 'iphone',
      _t: Date.now(),
    }
    const json = await fetch(
      getUrl(
        `/motor/discuss_ugc/cheyou_get_head/v1/?${serializeObject(params)}`,
        'motor.discuss.api_ugc'
      ),
      {
        credentials: 'include',
        mode: 'cors',
        headers: {
          Cookie: get(req, 'headers.cookie', ''),
        },
        req,
      }
    ).catch((e) => {
      // no-op
    })
    return json?.data || {}
  }
  const headerData = await getHeaderData()
  return {
    headerData,
    tab,
    series_id,
    _pageType: isNewVersion(req?._isNewVersion) ? 'full auto-nav' : '',
  }
}

export default Index
